import React, { ReactNode } from "react";
import { StyleSheet, ViewStyle } from "react-native";
import { LinearGradient } from "expo-linear-gradient";

type GradientBackgroundProps = {
  children: ReactNode;
  style?: ViewStyle | ViewStyle[];
//   colors?: string[];
  colors?: readonly [string, string, ...string[]]; 
  start?: { x: number; y: number };
  end?: { x: number; y: number };
};

export default function GradientBackground({
  children,
  style,
  colors = ["#C9EEF4", "#FFDFD4", "#FFEF97"], // default gradient
  start = { x: 0.85, y: 0 },
  end = { x: 1, y: 1 },
}: GradientBackgroundProps) {
  return (
    <LinearGradient
      colors={colors}
      locations={[0, 0.4856, 1]}
      start={{x: 0, y: 0.85}}    // tweak to taste
      end={{x: 0.15, y: 1}}
      // start={start}
      // end={end}
      style={[styles.container, style]}
    >
      {children}
    </LinearGradient>
  );
}

const styles = StyleSheet.create({
  container: {
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
    padding: 24,
    // marginHorizontal: 24,
     // iOS shadow
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 }, // x = 0, y = 4
    shadowOpacity: 0.1,                    // 10% opacity
    shadowRadius: 15,                      // blur radius

    // Android shadow
    elevation: 8,     
  },
});